import { render, staticRenderFns } from "./PriceReport.vue?vue&type=template&id=89f75714&scoped=true"
import script from "./PriceReport.vue?vue&type=script&lang=js"
export * from "./PriceReport.vue?vue&type=script&lang=js"
import style0 from "./PriceReport.vue?vue&type=style&index=0&id=89f75714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f75714",
  null
  
)

export default component.exports